import React from 'react'
import InputField from '../../../../commonComponents/formComponents/inputField'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { useSelector, useDispatch } from 'react-redux'
import { updatedeliveryTransportField, updateTransportationHeaderInfo } from '../../../actions'
import { Grid, Label } from 'semantic-ui-react'
import { useEvent } from '../../../hooks/useEvent'
import './deliveryTerms.css'
import UnlocodeField from './unlocodeField'
export default function DeliveryTerms(props) {
  const dispatch = useDispatch()
  const { saveForm } = useEvent('header', true)
  const saveData = (params) => saveForm({ transportation: params })
  const warehouseTypes = useSelector((state) => state.DropDownValues?.warehouseTypes) || []
  const incotermsDrpdwn = useSelector((state) => state.DropDownValues?.incoterms) || []
  const { id, incoterms, countryAndLocation, unlocode } = useSelector(
    (state) => state.Shipment.transportation.deliveryTerms
  )
  const { wareHouseType, wareHouseId } = useSelector((state) => state.Shipment.transportation)
  const saveDeliveryTransport = async (id, field, value) => {
    if (!id) {
      const response = await saveData({
        deliveryTerms: {
          id: '',
          [field]: value|| ' ',
        },
      })
      const currentID = response?.header?.transportation?.deliveryTerms?.id
      currentID && dispatch(updatedeliveryTransportField({ fieldName: 'id', currentID }))
    } else {
     let response = await saveData({
        deliveryTerms: {
          id: id,
          [field]: value || ' ',
        },
      })
    }
  }

  return (
    <React.Fragment>
      <Grid.Row className='theme-textbox border-b-0'>
        <label  className='label-address' style={{verticalAlign:"middle"}} >
        <span className="ui black label input-box-number">
                 4/1
        </span>
          Delivery Terms
          </label>
        <Grid.Column className='row' width='5'>
          <Label className='disabled title'>INCOTERMS :</Label>
          <DropDown
            id='incoTerms'
            className='field-bg dropdown100 theme-dropdown'
            labelClass='text-none'
            isLabel={false}
            data={incotermsDrpdwn}
            value={incoterms}
            clearable
            onChange={(value) => {
              saveDeliveryTransport(id, 'incoterms', value)

              dispatch(updatedeliveryTransportField({ fieldName: 'incoterms', value }))
            }}
          />
        </Grid.Column>
        <Grid.Column className='row' width='4'>
          <Label className='disabled title'>
            WAREHOUSE ID :
          </Label>
          <InputField
            isLabel={false}
            isFooterLabel={true}
            id='warehouseID'
            type='text'
            className={'field-bg'}
            clearInput={false}
            name='location'
            value={wareHouseId}
            onChange={(value) => {
              dispatch(updateTransportationHeaderInfo({ fieldName: 'wareHouseId', value }))
            }}
            onBlur={(value) =>
              saveData({
                wareHouseId: value || ' ',
              })
            }
          />
        </Grid.Column>
        <Grid.Column className='row' width='7'>
          <Label className='disabled title'>
            WAREHOUSE TYPE :
          </Label>
          <DropDown
            id='warehouseType'
            className='field-bg dropdown100 theme-dropdown'
            labelClass='text-none'
            isLabel={false}
            data={warehouseTypes}
            value={wareHouseType}
            clearable
            onChange={(value) => {
              saveData({
                wareHouseType: value,
              })
              dispatch(updateTransportationHeaderInfo({ fieldName: 'wareHouseType', value }))
            }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className='theme-textbox'>
        <Grid.Column width='8' className='divFormFeild unlocField'>
          <Label className='disabled title'>UNLOCODE :</Label>
          <UnlocodeField
            unlocode={unlocode}
            saveDeliveryTransport={saveDeliveryTransport}
            id={id}
            updateTransportationHeaderInfo={updateTransportationHeaderInfo}
          />
        </Grid.Column>
        <Grid.Column className='row' style={{ position: 'relative', bottom: '10px' }} width='8'>
          <Label className='disabled title'>LOCATION AND COUNTRY :</Label>
          <InputField
            isLabel={false}
            isFooterLabel={true}
            id='locationCountry'
            type='text'
            className={'field-bg'}
            clearInput={false}
            name='location'
            value={countryAndLocation}
            onChange={(value) => {
              dispatch(updatedeliveryTransportField({ fieldName: 'countryAndLocation', value }))
            }}
            onBlur={(value) => saveDeliveryTransport(id, 'countryAndLocation', value)}
          />
        </Grid.Column>
      </Grid.Row>
    </React.Fragment>
  )
}
